module.exports = __webpack_public_path__ + "media/steps/steps_bcg-3@2x-e0cd1228.png";